export default __webpack_public_path__ + "static/media/Chat.d244cbe7.svg";